// `!` on the border colour: globals.css's unlayered border-color beats a layered utility.
// `!` on the text size: the base items set a custom text token tailwind-merge can't replace.

/** Figma 564:84611 Filter / Sort Menu: 260 wide, 40px rows 4px apart. */
export const SORT_MENU = 'w-[260px] rounded-xl border-(--border-grey-subtle)! p-1';
export const SORT_MENU_GROUP = 'flex flex-col gap-1';
export const SORT_MENU_ITEM = 'min-h-10 rounded-lg py-2 text-[16px]/6! data-[state=checked]:bg-neutral-100';

/** Figma 564:89553 Menu / Row Actions: 268 wide, 36px rows 4px apart, 20px icons. shrink-0: a menu taller than the screen scrolls instead of squashing its rows. */
export const ROW_MENU =
  'flex w-[268px] flex-col gap-1 rounded-xl border-(--border-grey-subtle)! p-2 [&>*]:shrink-0 [&_[role=menuitem]]:min-h-9 [&_[role=menuitem]]:rounded [&_[role=menuitem]]:px-2 [&_[role=menuitem]]:py-1.5 [&_[role=menuitem]]:text-[16px]/6! [&_svg]:size-5!';
